import React, { useState } from "react";
import bannerImage from "../Img/banner2-right-image.png";
import { User, Smartphone, Mail, MessageCircle, Phone } from "react-feather";
import { sendToWhatsApp } from "./utils/Whatsapp";
import "../CSS/Partner.css";

const Partner = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    inquiry: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const message = `New request Form Submission from Partner With Us page:\n\n*Name:* ${formData.name}\n*Phone:* ${formData.phone}\n*Email:* ${formData.email}\n*Inquiry:* ${formData.inquiry}`;
    sendToWhatsApp(message);
    setFormData({ name: "", phone: "", email: "", inquiry: "" });
  };

  return (
    <div className="partner-page">
      <section className="partner-hero">
        <div className="partner-container">
          <div className="partner-hero-row">
            <div className="partner-hero-col">
              <h1 className="partner-hero-title">Become Our Partner</h1>
              <h2 className="partner-hero-subtitle">
                & Earn Regular Income with Your Cycle
              </h2>
              <p className="partner-hero-text">
                CRS lets you earn through bookings from customers all over
                Mumbai, who rent your cycle on a monthly to yearly basis.
              </p>
              <div className="partner-hero-col--cta">
                <a
                  href="https://wa.me/+918082080816?text=Hey%20Twin%20Tring,%20I'm%20interested%20in%20renting%20out%20my%20bicycle.%20Here%20are%20the%20details."
                  target="_blank"
                  rel="noreferrer"
                  className="partner-cta-btn"
                >
                  Register Now &nbsp; <i className="fa fa-long-arrow-right"></i>
                </a>
              </div>
            </div>
            <div className="partner-hero-col partner-hero-col--image">
              <img
                src={bannerImage}
                alt="Partner with Cycle Rental Services"
                className="partner-hero-image"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="partner-how">
        <div className="partner-container">
          <h2 className="partner-section-title">How Does It Work?</h2>
          <div className="partner-steps-row">
            <div className="partner-step-col">
              <p className="partner-step-label">STEP 1</p>
              <div className="partner-step-card">
                <p className="partner-step-card-title">Register Your Cycle</p>
                <p className="partner-step-card-text">
                  Photos & details of your cycles will be listed on our website.
                </p>
              </div>
            </div>
            <div className="partner-step-col">
              <p className="partner-step-label">STEP 2</p>
              <div className="partner-step-card">
                <p className="partner-step-card-title">Your Cycle Gets Booked</p>
                <p className="partner-step-card-text">
                  Customers book your cycle for a duration of 1 to 12 months.
                </p>
              </div>
            </div>
            <div className="partner-step-col">
              <p className="partner-step-label">STEP 3</p>
              <div className="partner-step-card">
                <p className="partner-step-card-title">Receive Payment</p>
                <p className="partner-step-card-text">
                  Monthly rent of the cycle is transferred directly into your bank
                  account.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="partner-commission">
        <div className="partner-container partner-container--narrow">
          <div className="partner-commission-inner">
            <h2 className="partner-section-title">Commission & Payment</h2>
            <p className="partner-commission-percent">25%</p>
            <p className="partner-commission-desc">
              of every booking amount is transferred to your linked bank account
              directly.
            </p>
            <p className="partner-commission-note">
              You can opt out anytime.
              <br />
              We will <b>delist your cycle</b> from our website & you will stop
              getting bookings.
            </p>
          </div>
        </div>
      </section>

      <section className="help-section">
        <div className="help-overlay"></div>
        <div className="container">
          <div className="help-content">
            <h2 className="help-title">Have Questions?</h2>

            <div className="help-contact">
              <div className="help-contact-item">
                <Phone size={20} />
                <a href="tel:+918082080816">+91 8082080816</a>
              </div>
              <div className="help-contact-item">
                <Mail size={20} />
                <a href="mailto:cyclerental@gmail.com">cyclerental@gmail.com</a>
              </div>
            </div>

            <form className="help-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <User size={18} className="form-icon" />
                <input
                  type="text"
                  placeholder="Full Name"
                  value={formData.name}
                  required
                  onChange={(e) =>
                    setFormData({ ...formData, name: e.target.value })
                  }
                />
              </div>

              <div className="form-group">
                <Smartphone size={18} className="form-icon" />
                <input
                  type="tel"
                  placeholder="Mobile Number"
                  value={formData.phone}
                  required
                  onChange={(e) =>
                    setFormData({ ...formData, phone: e.target.value })
                  }
                />
              </div>

              <div className="form-group">
                <Mail size={18} className="form-icon" />
                <input
                  type="email"
                  placeholder="Email"
                  value={formData.email}
                  required
                  onChange={(e) =>
                    setFormData({ ...formData, email: e.target.value })
                  }
                />
              </div>

              <div className="form-group">
                <MessageCircle size={18} className="form-icon" />
                <input
                  type="text"
                  placeholder="What are you looking for?"
                  value={formData.inquiry}
                  onChange={(e) =>
                    setFormData({ ...formData, inquiry: e.target.value })
                  }
                />
              </div>

              <button type="submit" className="help-submit-btn">
                Submit
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Partner;
